export default "__VITE_ASSET__BwxvYo_7__"